import Vue, { computed } from "vue";
import VueI18n from "vue-i18n";
import { setupTheming as setupTheming$1, useTheming as useTheming$1 } from "@loopia-group/services";
const WsAnalyticsDirective = {
  update: bind,
  inserted: bind
};
function bind(el, binding) {
  var _a;
  if (!window.ws_analytics) {
    return null;
  }
  if (!el.getAttribute("data-tracking")) {
    el.setAttribute("data-tracking", binding.value);
  }
  if ((_a = window.ws_analytics.stored) == null ? void 0 : _a[binding.value]) {
    Object.keys(window.ws_analytics.stored[binding.value]).forEach((key) => {
      el.addEventListener(key, window.ws_analytics.stored[binding.value][key]);
    });
    delete window.ws_analytics.stored[binding.value];
  }
}
const SCREEN_SIZE_MD = 1024;
const SCREEN_SIZE_LG = 1440;
const $q = Vue;
const mobile = computed(() => {
  return SCREEN_SIZE_MD > ($q == null ? void 0 : $q.screen.width);
});
const tablet = computed(() => {
  const screenWidth = $q == null ? void 0 : $q.screen.width;
  return SCREEN_SIZE_MD <= screenWidth && SCREEN_SIZE_LG > screenWidth;
});
const desktop = computed(() => {
  return SCREEN_SIZE_LG <= ($q == null ? void 0 : $q.screen.width);
});
let router;
const initRouter = (routerInstance) => {
  router = routerInstance;
};
const useRouter = () => router;
let i18nInstance = VueI18n;
function createI18n(options) {
  i18nInstance = new VueI18n(options);
  return i18nInstance;
}
function useTranslation(instance) {
  if (!i18nInstance) {
    throw new Error("vue-i18n not initialized");
  }
  const i18n = i18nInstance;
  const vm = (instance == null ? void 0 : instance.proxy) || instance || new Vue({});
  const locale = computed({
    get() {
      return i18n.locale;
    },
    set(v) {
      i18n.locale = v;
    }
  });
  return {
    locale,
    t: vm.$t.bind(vm),
    $t: vm.$t.bind(vm)
  };
}
const setupGlobalMixins = (quasarScreen, lodashGet) => ({
  data: function() {
    return {
      deviceInfo
    };
  },
  computed: {
    mobile() {
      var _a, _b;
      return quasarScreen.sizes.md > ((_b = (_a = this.$q) == null ? void 0 : _a.screen) == null ? void 0 : _b.width);
    },
    tablet() {
      var _a;
      const screenWidth = (_a = this.$q) == null ? void 0 : _a.screen.width;
      return quasarScreen.sizes.md <= screenWidth && quasarScreen.sizes.lg > screenWidth;
    },
    desktop() {
      var _a;
      return quasarScreen.sizes.lg <= ((_a = this.$q) == null ? void 0 : _a.screen.width);
    }
  },
  methods: {
    get: lodashGet,
    isTheme(theme) {
      return this.$store.getters["theme/currentTheme"] === theme;
    },
    currentTheme() {
      var _a, _b;
      return (_b = (_a = this.$store) == null ? void 0 : _a.getters) == null ? void 0 : _b["theme/currentTheme"];
    }
  }
});
const deviceInfo = Vue.observable({
  touchInUse: "ontouchstart" in window || window.navigator.maxTouchPoints > 0,
  init() {
    let deactivatedMouse = false;
    let timeOut = null;
    document.body.addEventListener(
      "mouseover",
      () => this.touchInUse = deactivatedMouse
    );
    document.body.addEventListener("touchstart", () => {
      this.touchInUse = true;
      deactivatedMouse = true;
      if (timeOut) {
        clearTimeout(timeOut);
      }
      timeOut = setTimeout(() => {
        deactivatedMouse = false;
      }, 1e3);
    });
  }
});
let _theme = void 0;
const useTheming = () => {
  if (!_theme) {
    console.error("Theme is not set");
  }
  return {
    theme: _theme,
    isTheme
  };
};
const isTheme = (theme) => {
  return (_theme == null ? void 0 : _theme.value) === theme;
};
const setupTheming = (vue, ref, opt) => {
  _theme = ref(opt.theme);
  const themeOptions = {
    theme: opt.theme,
    env: opt.env,
    onTheme: (value) => {
      if (_theme) {
        return _theme.value = value;
      }
      return null;
    }
  };
  setupTheming$1(themeOptions);
  vue.use(themingVuePlugin);
};
const themingVuePlugin = {
  install: (app) => {
    const { theme } = useTheming$1();
    if (_theme) {
      _theme.value = theme;
    }
    app.prototype.$theme = _theme;
  }
};
Vue.config.productionTip = false;
Vue.config.devtools = false;
export { WsAnalyticsDirective, bind, createI18n, desktop, deviceInfo, initRouter, mobile, setupGlobalMixins, setupTheming, tablet, themingVuePlugin, useRouter, useTheming, useTranslation };
//# sourceMappingURL=index.es.js.map
